var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from "react";
import { Controller, } from "react-hook-form";
import { useIntl } from "react-intl";
import { Checkbox, Col, Row, Selection } from "@folio/stripes/components";
import { useAddress } from "../../hooks/useAddress";
import { RecekSelect, RecekTextField } from "../inputs";
export var PublisherAddress = function (_a) {
    var type = _a.type, control = _a.control, errors = _a.errors, setValue = _a.setValue, regions = _a.regions, _b = _a.addressFieldsRequired, addressFieldsRequired = _b === void 0 ? true : _b;
    var formatMessage = useIntl().formatMessage;
    var _c = useAddress(type, setValue), addressQuery = _c.addressQuery, handleAddressQuery = _c.handleAddressQuery, setAddressCode = _c.setAddressCode, addressDataOptions = _c.addressDataOptions, handleToggleAddress = _c.handleToggleAddress, enableAddress = _c.enableAddress;
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, null,
            React.createElement(Col, { xs: 12, md: 6 },
                React.createElement(Selection, { label: formatMessage({
                        id: "ui-br-legaldeposits.publishers.field.address.search",
                    }), placeholder: formatMessage({
                        id: "ui-br-legaldeposits.publishers.field.address.search.placeholder",
                    }), dataOptions: addressDataOptions, value: addressQuery, onFilter: handleAddressQuery, onChange: setAddressCode, asyncFilter: true, disabled: enableAddress })),
            React.createElement(Col, { xs: 12, md: 6 },
                React.createElement(Checkbox, { label: formatMessage({
                        id: "ui-br-legaldeposits.publishers.field.enableManualAddress",
                    }), checked: enableAddress, onChange: handleToggleAddress }))),
        React.createElement(Row, null,
            React.createElement(Col, { xs: 12, md: 6 },
                React.createElement(Controller, { control: control, name: "".concat(type, ".municipality"), render: function (_a) {
                        var _b, _c;
                        var field = _a.field;
                        return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-legaldeposits.publishers.field.address.municipality", required: addressFieldsRequired, disabled: !enableAddress, error: (_c = (_b = errors[type]) === null || _b === void 0 ? void 0 : _b.municipality) === null || _c === void 0 ? void 0 : _c.message })));
                    } })),
            React.createElement(Col, { xs: 12, md: 6 },
                React.createElement(Controller, { control: control, name: "".concat(type, ".regionId"), render: function (_a) {
                        var _b, _c;
                        var field = _a.field;
                        return (React.createElement(RecekSelect, __assign({}, field, { labelId: "ui-br-legaldeposits.publishers.field.address.region", required: true, disabled: !enableAddress, error: (_c = (_b = errors[type]) === null || _b === void 0 ? void 0 : _b.regionId) === null || _c === void 0 ? void 0 : _c.message, dataOptions: __spreadArray([
                                {
                                    value: "",
                                    label: formatMessage({
                                        id: "ui-br-legaldeposits.filter.select.all",
                                    }),
                                }
                            ], regions.map(function (region) {
                                var _a, _b;
                                return ({
                                    value: (_a = region.id) !== null && _a !== void 0 ? _a : "",
                                    label: (_b = region.name) !== null && _b !== void 0 ? _b : "",
                                });
                            }), true) })));
                    } }))),
        React.createElement(Row, null,
            React.createElement(Col, { xs: 12, md: 6 },
                React.createElement(Controller, { control: control, name: "".concat(type, ".street"), render: function (_a) {
                        var _b, _c;
                        var field = _a.field;
                        return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-legaldeposits.publishers.field.address.street", required: addressFieldsRequired, disabled: !enableAddress, error: (_c = (_b = errors[type]) === null || _b === void 0 ? void 0 : _b.street) === null || _c === void 0 ? void 0 : _c.message })));
                    } })),
            React.createElement(Col, { xs: 12, md: 6 },
                React.createElement(Controller, { control: control, name: "".concat(type, ".postalCode"), render: function (_a) {
                        var _b, _c;
                        var field = _a.field;
                        return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-legaldeposits.publishers.field.address.postalCode", required: addressFieldsRequired, disabled: !enableAddress, error: (_c = (_b = errors[type]) === null || _b === void 0 ? void 0 : _b.postalCode) === null || _c === void 0 ? void 0 : _c.message })));
                    } })))));
};
